// ============================================================================
// CASE SECURITY SERVICE — Phase 5.6
// ============================================================================
// Junction case ↔ security. Auto-populated on claim; UI edits in_scope and
// is_primary post-claim.

import { get, patch } from '../client/axiosClient';
import { caseSecurityEndpoints } from '../endpoints/caseSecurity.endpoints';
import type { ApiResponse, ID } from '../types';
import type {
  CaseSecurity,
  SetPrimaryCaseSecurityRequest,
  UpdateCaseSecurityScopeRequest,
} from '../types/caseSecurity.types';

class CaseSecurityService {
  async getByCase(caseId: ID): Promise<CaseSecurity[]> {
    const res = await get<ApiResponse<CaseSecurity[]>>(caseSecurityEndpoints.byCase(caseId));
    return res.data?.data ?? [];
  }

  async getInScope(caseId: ID): Promise<CaseSecurity[]> {
    const res = await get<ApiResponse<CaseSecurity[]>>(caseSecurityEndpoints.inScope(caseId));
    return res.data?.data ?? [];
  }

  async updateScope(id: ID, body: UpdateCaseSecurityScopeRequest): Promise<CaseSecurity> {
    const res = await patch<ApiResponse<CaseSecurity>>(caseSecurityEndpoints.updateScope(id), body);
    return res.data.data!;
  }

  async setPrimary(id: ID, body: SetPrimaryCaseSecurityRequest): Promise<CaseSecurity> {
    const res = await patch<ApiResponse<CaseSecurity>>(caseSecurityEndpoints.setPrimary(id), body);
    return res.data.data!;
  }
}

export const caseSecurityService = new CaseSecurityService();
